import { Table } from "antd";
import styled from "styled-components";
import tw from "twin.macro";

export const StyledTable = styled(Table)`
  ${tw`rounded-app shadow`}
`;
